import {
  BonusStrategy,
  BonusType,
  BonusResult,
  ConfettiConfig,
  AmountConstraints,
} from '../interfaces/bonus.interface';

export class YoMeLlamoCdtBonusStrategy implements BonusStrategy {
  type = BonusType.YO_ME_LLAMO_CDT;
  campaignSpecific = true; // Bono específico de la campaña "Yo Me Llamo CDT"

  validateAmount(amount: number): boolean {
    return amount >= 5000000;
  }

  calculateBonus(amount: number, termDays: number): BonusResult {
    const terms = this.getTermsAndConditions();
    if (!this.validateAmount(amount)) {
      return {
        isValid: false,
        bonusAmount: 0,
        message: '',
        confettiType: '',
        termsAndConditionsUrl: terms.url,
        termsAndConditionsDescription: terms.description,
      };
    }
    let bonusAmount = 0;
    if (amount >= 200000000) {
      bonusAmount = 1000000 * (termDays / 360);
      return {
        isValid: true,
        bonusAmount: Math.round(bonusAmount),
        message: 'Además de tu rentabilidad, llévate <b class="tag-bono-amt text-white py-1 px-3 rounded-pill">$1.000.000</b> extra directo a tu cuenta.',
        message_simulador: 'Puedes aplicar para un bono de $1.000.000. Continua con <b>la apertura de tu CDT</b> para obtenerlo.',
        confettiType: 'snow',
        displayAmount: '$1.000.000',
        bonusTag: '1000k',
        minTermDays: [30, 60, 90, 180],
        tagNameBonusType: 'MES_AHORRO_ESCALONADO_1M',
        termsAndConditionsUrl: terms.url,
        termsAndConditionsDescription: terms.description,
      };
    } else if (amount >= 100000000) {
      bonusAmount = 500000 * (termDays / 360);
      return {
        isValid: true,
        bonusAmount: Math.round(bonusAmount),
        message: 'Además de tu rentabilidad, llévate <b class="tag-bono-amt text-white py-1 px-3 rounded-pill">$500.000</b> extra directo a tu cuenta.',
        message_simulador: 'Puedes aplicar para un bono de $500.000. Continua con <b>la apertura de tu CDT</b> para obtenerlo.',
        confettiType: 'snow',
        displayAmount: '$500.000',
        bonusTag: '500k',
        minTermDays: [30, 60, 90, 180],
        tagNameBonusType: 'MES_AHORRO_ESCALONADO_500K',
        termsAndConditionsUrl: terms.url,
        termsAndConditionsDescription: terms.description,
      };
    } else if (amount >= 50000000) {
      bonusAmount = 300000 * (termDays / 360);
      return {
        isValid: true,
        bonusAmount: Math.round(bonusAmount),
        message: 'Además de tu rentabilidad, llévate <b class="tag-bono-amt text-white py-1 px-3 rounded-pill">$300.000</b> extra directo a tu cuenta.',
        message_simulador: 'Puedes aplicar para un bono de $300.000. Continua con <b>la apertura de tu CDT</b> para obtenerlo.',
        confettiType: 'snow',
        displayAmount: '$300.000',
        bonusTag: '300k',
        minTermDays: [30, 60, 90, 180],
        tagNameBonusType: 'MES_AHORRO_ESCALONADO_300K',
        termsAndConditionsUrl: terms.url,
        termsAndConditionsDescription: terms.description,
      };
    } else if (amount >= 30000000) {
      bonusAmount = 150000 * (termDays / 360);
      return {
        isValid: true,
        bonusAmount: Math.round(bonusAmount),
        message: 'Además de tu rentabilidad, llévate <b class="tag-bono-amt text-white py-1 px-3 rounded-pill">$150.000</b> extra directo a tu cuenta.',
        message_simulador: 'Puedes aplicar para un bono de $150.000. Continua con <b>la apertura de tu CDT</b> para obtenerlo.',
        confettiType: 'snow',
        displayAmount: '$150.000',
        bonusTag: '150k',
        minTermDays: [30, 60, 90, 180],
        tagNameBonusType: 'MES_AHORRO_ESCALONADO_150K',
        termsAndConditionsUrl: terms.url,
        termsAndConditionsDescription: terms.description,
      };
    } else if (amount >= 10000000) {
      bonusAmount = 50000 * (termDays / 360);
      return {
        isValid: true,
        bonusAmount: Math.round(bonusAmount),
        message: 'Además de tu rentabilidad, llévate <b class="tag-bono-amt text-white py-1 px-3 rounded-pill">$50.000</b> extra directo a tu cuenta.',
        message_simulador: 'Puedes aplicar para un bono de $50.000. Continua con <b>la apertura de tu CDT</b> para obtenerlo.',
        confettiType: 'snow',
        displayAmount: '$50.000',
        bonusTag: '50k',
        minTermDays: [30, 60, 90, 180],
        tagNameBonusType: 'MES_AHORRO_ESCALONADO_50K',
        termsAndConditionsUrl: terms.url,
        termsAndConditionsDescription: terms.description,
      };
    } else if (amount >= 5000000) {
      bonusAmount = 25000 * (termDays / 360);
      return {
        isValid: true,
        bonusAmount: Math.round(bonusAmount),
        message: 'Además de tu rentabilidad, llévate <b class="tag-bono-amt text-white py-1 px-3 rounded-pill">$25.000</b> extra directo a tu cuenta.',
        message_simulador: 'Puedes aplicar para un bono de $25.000. Continua con <b>la apertura de tu CDT</b> para obtenerlo.',
        confettiType: 'snow',
        displayAmount: '$25.000',
        bonusTag: '25k',
        minTermDays: [30, 60, 90, 180],
        tagNameBonusType: 'MES_AHORRO_ESCALONADO_25K',
        termsAndConditionsUrl: terms.url,
        termsAndConditionsDescription: terms.description,
      };
    }
    return {
      isValid: false,
      bonusAmount: 0,
      message: '',
      confettiType: '',
      termsAndConditionsUrl: terms.url,
      termsAndConditionsDescription: terms.description,
    };
  }

  getTermsAndConditions(): { url: string; description: string } {
    return {
      url: '/legal/yo-me-llamo-cdt',
      description: 'Aplican términos y condiciones para la campaña Yo Me Llamo CDT. Esta promoción requiere un plazo mínimo de 360 días (12 meses) y montos desde $5,000,000 COP. El bono es un cashback que se deposita directamente en tu cuenta bancaria personal una vez que tu CDT esté activo.',
    };
  }

  getConfettiConfig(): ConfettiConfig {
    return {
      type: 'snow',
      duration: 4000,
      intensity: 'medium',
    };
  }

  getAmountConstraints(): AmountConstraints {
    return {
      locked: false,
      minAmount: 5000000,
    };
  }
}